"use strict";

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.reduce");

var _toConsumableArray = require("/home/sam/Desktop/projects/startups/explot/app/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.set");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var enums_1 = require("../enums"); // source: https://stackoverflow.com/questions/49875255

/**
 * @param modifiers
 */


function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  /**
   * @param modifier
   */

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(_toConsumableArray(modifier.requires || []), _toConsumableArray(modifier.requiresIfExists || []));
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}
/**
 * @param modifiers
 */


function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return enums_1.modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

exports["default"] = orderModifiers;